function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "mobile_x5F_search",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 16.313,
    y: 14.926,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -7.1711 17.3125)",
    style: {
      fill: "#FD5C3F"
    },
    width: 2,
    height: 4.773
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD5C3F"
    },
    d: "M21,18.828L29.172,27L27,29.172L18.828,21L21,18.828 M21,16l-5,5l11,11l5-5L21,16L21,16z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 20.379,
    y: 21.5,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -9.3198 22.5)",
    style: {
      fill: "#FD5C3F"
    },
    width: 4.243,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 23.379,
    y: 24.5,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -10.5624 25.5)",
    style: {
      fill: "#FD5C3F"
    },
    width: 4.243,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD5C3F"
    },
    d: "M10,20C4.486,20,0,15.514,0,10S4.486,0,10,0s10,4.486,10,10S15.514,20,10,20z M10,2 c-4.411,0-8,3.589-8,8s3.589,8,8,8s8-3.589,8-8S14.411,2,10,2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileSearch);
export default __webpack_public_path__ + "static/media/mobile_search.ac6ad6e4e166d21a24b1ab488bd51723.svg";
export { ForwardRef as ReactComponent };